import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const prepositionQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Confío ___ que todo saldrá bien.'",
        options: ["en", "de", "a", "con"],
        correctAnswerIndex: 0,
        explanation: "'En' es la preposición correcta, ya que 'confiar en' es una expresión que se usa para indicar confianza en algo o alguien."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Selecciona la opción correcta: 'Dependo ___ mis padres para pagar la universidad.'",
        options: ["en", "de", "con", "por"],
        correctAnswerIndex: 1,
        explanation: "'De' es la preposición correcta, ya que 'depender de' se usa para indicar que alguien necesita algo o a alguien para lograr algo."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la frase: 'Voy a casarme ___ mi novio el próximo mes.'",
        options: ["a", "con", "de", "en"],
        correctAnswerIndex: 1,
        explanation: "'Con' es la preposición correcta, ya que 'casarse con' es la expresión usada para indicar con quién se va a casarse una persona."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Elige la opción correcta: 'Estoy interesado ___ aprender a hablar francés.'",
        options: ["en", "de", "a", "por"],
        correctAnswerIndex: 0,
        explanation: "'En' es la preposición correcta, ya que 'interesarse en' indica interés por algo."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Elige la opción correcta: '¿Puedo contar ___ ti para este proyecto?'",
        options: ["en", "de", "a", "con"],
        correctAnswerIndex: 3,
        explanation: "'Con' es la preposición correcta, ya que 'contar con' significa poder confiar en alguien para algo."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la frase: 'El niño está jugando ___ la pelota en el jardín.'",
        options: ["con", "por", "en", "de"],
        correctAnswerIndex: 0,
        explanation: "'Con' es la preposición correcta, ya que se utiliza cuando se habla de la acción de hacer algo con un objeto."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'El regalo es ___ mi hermana.'",
        options: ["para", "por", "a", "de"],
        correctAnswerIndex: 0,
        explanation: "'Para' es la preposición correcta, ya que indica destino o finalidad, en este caso el regalo va dirigido a alguien."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Elige la opción correcta: 'La tienda está abierta ___ las 9 de la mañana.'",
        options: ["en", "a", "de", "por"],
        correctAnswerIndex: 1,
        explanation: "'A' es la preposición correcta, ya que 'a' se usa para indicar una hora específica en este contexto."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Selecciona la opción correcta: '¿Quieres venir ___ mí al cine?'",
        options: ["con", "a", "para", "de"],
        correctAnswerIndex: 0,
        explanation: "'Con' es la preposición correcta, ya que 'venir con' indica acompañamiento."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Las llaves están ___ la mesa.'",
        options: ["en", "a", "sobre", "de"],
        correctAnswerIndex: 2,
        explanation: "'Sobre' es la preposición correcta, ya que indica que algo está encima de otra cosa."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Elige la opción correcta: 'Te llamaré ___ la tarde.'",
        options: ["en", "a", "por", "de"],
        correctAnswerIndex: 0,
        explanation: "'En' es la preposición correcta, ya que se usa para hablar de una parte del día."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la frase: 'Voy ___ la casa de Juan a las 6.'",
        options: ["a", "para", "con", "de"],
        correctAnswerIndex: 0,
        explanation: "'A' es la preposición correcta, ya que indica movimiento hacia un lugar."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Selecciona la opción correcta: 'Estaba preocupado ___ la situación económica.'",
        options: ["en", "de", "por", "con"],
        correctAnswerIndex: 2,
        explanation: "'Por' es la preposición correcta, ya que 'preocuparse por' es la forma adecuada para hablar de lo que causa la preocupación."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Selecciona la preposición correcta: 'Ella se queja ___ el mal servicio en el restaurante.'",
        options: ["en", "de", "por", "a"],
        correctAnswerIndex: 1,
        explanation: "'De' es la preposición correcta, ya que 'quejarse de' es la expresión que se usa para indicar la causa de una queja."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Estoy cansado ___ estudiar tanto.'",
        options: ["de", "por", "en", "a"],
        correctAnswerIndex: 0,
        explanation: "'De' es la preposición correcta, ya que 'estar cansado de' es la expresión que se usa para indicar la causa de estar cansado."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Estoy pensando ___ mis vacaciones en la playa.'",
        options: ["por", "a", "sobre", "en"],
        correctAnswerIndex: 3,
        explanation: "'En' es la preposición correcta, ya que 'pensar en' se usa para referirse a algo o alguien en lo que se está pensando."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Ella sueña ___ viajar por todo el mundo.'",
        options: ["con", "de", "a", "en"],
        correctAnswerIndex: 0,
        explanation: "'Con' es la preposición correcta, ya que 'soñar con' se usa para hablar de algo deseado o imaginado."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Me enamoré ___ una persona muy especial.'",
        options: ["a", "en", "de", "por"],
        correctAnswerIndex: 2,
        explanation: "'De' es la preposición correcta, ya que 'enamorarse de' se usa para indicar el objeto de amor o atracción."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Nos estamos enfocando ___ mejorar nuestras habilidades.'",
        options: ["a", "en", "por", "de"],
        correctAnswerIndex: 1,
        explanation: "'En' es la preposición correcta, ya que 'enfocarse en' se usa para referirse a un objetivo o punto de atención."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Ellos se sorprendieron ___ recibir tantas cartas.'",
        options: ["al", "de", "por", "a"],
        correctAnswerIndex: 2,
        explanation: "'Por' es la preposición correcta, ya que 'sorprenderse por' se usa para indicar la causa de la sorpresa."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Estoy interesado ___ aprender nuevas lenguas.'",
        options: ["en", "a", "de", "por"],
        correctAnswerIndex: 0,
        explanation: "'En' es la preposición correcta, ya que 'interesado en' se usa para referirse a lo que te interesa o atrae."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Elige la opción correcta: 'Este libro trata ___ la historia de la Segunda Guerra Mundial.'",
        options: ["sobre", "de", "a", "en"],
        correctAnswerIndex: 0,
        explanation: "'Sobre' es la preposición correcta, ya que 'tratar sobre' indica el tema de algo, como en este caso, un libro."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Selecciona la opción correcta: 'Voy a ir ___ la tienda después del trabajo.'",
        options: ["para", "de", "en", "a"],
        correctAnswerIndex: 3,
        explanation: "'A' es la preposición correcta, ya que 'ir a' es la forma correcta para indicar destino o dirección."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Acabo ___ comer.'",
        options: ["de", "por", "a", "en"],
        correctAnswerIndex: 0,
        explanation: "'De' es la preposición correcta, ya que 'acabar de' se usa para indicar que algo se ha terminado de hacer recientemente."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Me di cuenta ___ mi error demasiado tarde.'",
        options: ["por", "en", "de", "a"],
        correctAnswerIndex: 2,
        explanation: "'De' es la preposición correcta, ya que 'darse cuenta de' se usa para indicar que alguien percibe o comprende algo."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Ella dejó ___ fumar hace un mes.'",
        options: ["de", "por", "a", "en"],
        correctAnswerIndex: 0,
        explanation: "'De' es la preposición correcta, ya que 'dejar de' se usa para indicar que se abandona una actividad."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Completa la oración: 'Voy a pasar ___ tu casa antes de ir al trabajo.'",
        options: ["por", "a", "en", "de"],
        correctAnswerIndex: 0,
        explanation: "'Por' es la preposición correcta, ya que 'pasar por' se usa para indicar un lugar por el que se transita o se hace una parada temporal."
    },
    {
        category: QuizCategory.PREPOSITIONS,
        questionText: "Elige la opción correcta: 'Estoy preocupado ___ los exámenes que tengo la próxima semana.'",
        options: ["por", "de", "a", "en"],
        correctAnswerIndex: 0,
        explanation: "'Por' es la preposición correcta, ya que 'preocuparse por' es la expresión que indica el objeto de la preocupación."
    }
];

export default prepositionQuestions;